import { resource, RequestConfig } from '../helper/resource';

/**
 * 取消定投
 */
export function cancelFixedInvestUsingPOST(
  req: FinancialPositionDto | void,
  config?: RequestConfig
): Promise<ApiResultCancelFixedInvestDto> {
  return resource.post('/financialPosition/cancelFixedInvest', req, config);
}

/**
 * 报价回购代理委托协议注销
 */
export function cancelQuoteBackUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultCancelQuoteBackDto> {
  return resource.post('/financialPosition/cancelQuoteBack', req, config);
}

/**
 * 确认风险变更
 */
export function confirmRiskChangeUsingPOST(req: ProdRiskCustDto | void, config?: RequestConfig): Promise<ApiResult> {
  return resource.post('/financialPosition/confirmRiskChange', req, config);
}

/**
 * 查询资产分析的基础url
 */
export function queryAssetAnalysisUrlUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.post('/financialPosition/queryAssetAnalysisUrl', req, config);
}

/**
 * 定期列表
 */
export function queryFixedDateLIstUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<ApiResultFinancialPositionResultDto> {
  return resource.post('/financialPosition/queryFixedDateLIst', req, config);
}

/**
 * queryFundNav
 */
export function queryFundNavUsingPOST(req: NavDto | void, config?: RequestConfig): Promise<OpenFund> {
  return resource.post('/financialPosition/queryFundNav', req, config);
}

/**
 * 基金走势
 */
export function queryFundTrendListUsingPOST(
  req: NavDto | void,
  config?: RequestConfig
): Promise<ApiResultListOpenFund> {
  return resource.post('/financialPosition/queryFundTrendList', req, config);
}

/**
 * 高端列表
 */
export function queryHighEndLIstUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<ApiResultFinancialPositionResultDto> {
  return resource.post('/financialPosition/queryHighEndLIst', req, config);
}

/**
 * 单产品的收益明细列表
 */
export function queryIncomeDetailByMonthUsingPOST(
  req: FinancialPositionDto | void,
  config?: RequestConfig
): Promise<ApiResultIncomeDetailDto> {
  return resource.post('/financialPosition/queryIncomeDetailByMonth', req, config);
}

/**
 * 下面的:收益明细列表
 */
export function queryIncomeDetailListUsingPOST(
  req: FinancialPositionDto | void,
  config?: RequestConfig
): Promise<ApiResultListIncomeDetailMonthDto> {
  return resource.post('/financialPosition/queryIncomeDetailList', req, config);
}

/**
 * 上面的:收益明细上面的两个数字
 */
export function queryIncomeTotalInfoUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultIncomeTotalInfo> {
  return resource.post('/financialPosition/queryIncomeTotalInfo', req, config);
}

/**
 * queryIndexQuote
 */
export function queryIndexQuoteUsingPOST(req: NavDto | void, config?: RequestConfig): Promise<Array<MarketQuote>> {
  return resource.post('/financialPosition/queryIndexQuote', req, config);
}

/**
 * 沪深300走势
 */
export function queryMarketQuoteTrendListUsingPOST(
  req: NavDto | void,
  config?: RequestConfig
): Promise<ApiResultListMarketQuote> {
  return resource.post('/financialPosition/queryMarketQuoteTrendList', req, config);
}

/**
 * 查询昨日收益
 */
export function queryPreProfitUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultProductTotalInfo> {
  return resource.post('/financialPosition/queryPreProfit', req, config);
}

/**
 * 收益凭证持仓详情
 */
export function queryProfitProofDetailUsingPOST(
  req: FinancialPositionDto | void,
  config?: RequestConfig
): Promise<ApiResultProductDetailInfo> {
  return resource.post('/financialPosition/queryProfitProofDetail', req, config);
}

/**
 * 公募、高端详情和公募持仓详情页的产品状态和业务控制串
 */
export function queryPublicFundDetailUsingPOST(
  req: FinancialPositionDto | void,
  config?: RequestConfig
): Promise<ApiResultProductDetailInfo> {
  return resource.post('/financialPosition/queryPublicFundDetail', req, config);
}

/**
 * 基金列表
 */
export function queryPublicPositionListUsingPOST(
  req: void,
  config?: RequestConfig
): Promise<ApiResultFinancialPositionResultDto> {
  return resource.post('/financialPosition/queryPublicPositionList', req, config);
}

/**
 * 报价回购持仓详情
 */
export function queryQuoteBackDetailUsingPOST(
  req: FinancialPositionDto | void,
  config?: RequestConfig
): Promise<ApiResultQuoteBackDetail> {
  return resource.post('/financialPosition/queryQuoteBackDetail', req, config);
}

/**
 * 查询某用户的风险变更提示列表
 */
export function queryRiskCustListUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultListProdRiskCust> {
  return resource.post('/financialPosition/queryRiskCustList', req, config);
}

/**
 * 未确认交易数&&公募持仓单产品的交易中的也是这个接口
 */
export function queryUnconfirmedTradeNumUsingPOST(
  req: FinancialPositionDto | void,
  config?: RequestConfig
): Promise<ApiResultint> {
  return resource.post('/financialPosition/queryUnconfirmedTradeNum', req, config);
}

/**
 * 赎回费用提醒
 */
export function redemptionRemindUsingPOST(
  req: Production | void,
  config?: RequestConfig
): Promise<ApiResultRedemptionInfoDto> {
  return resource.post('/financialPosition/redemptionRemind', req, config);
}

/**
 * syncRiskCustByDay
 */
export function syncRiskCustByDayUsingPOST(req: void, config?: RequestConfig): Promise<void> {
  return resource.post('/financialPosition/syncRiskCustByDay', req, config);
}
